import * as Yup from "yup";
import i18n from "../i18n";

export const ManageRolesSchema = Yup.object({
  roleNameEn: Yup.string().required(
    i18n.language === "en"
      ? "Role Name - English is required"
      : "اسم الدور - بالإنجليزية مطلوب"
  ),
  roleNameAr: Yup.string().required(
    i18n.language === "en"
      ? "Role Name - Arabic is required"
      : "اسم الدور - بالعربية مطلوب"
  ),
});
